import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { useUploadAssetMediasMutation } from "@/lib/queries/asset-media-queries";
import { SceneTypeDto } from "@repo/api/overlays";
import { useDropzone } from "react-dropzone";
import { useParams } from "react-router";

export function useElementMediaDropzone(
  sceneType: SceneTypeDto,
  isEnabled: boolean = true,
) {
  const { teamExternalId } = useParams();

  const addAssetMediaElements = useEditorStore(
    (state) => state.service.addAssetMediaElements,
  );

  const { mutate: uploadAssetMedias, isPending: isUploadingMedia } =
    useUploadAssetMediasMutation({
      teamExternalId: teamExternalId!,
      onSuccess: (uploadedMedias) => {
        addAssetMediaElements(uploadedMedias, sceneType);
      },
    });

  const { getRootProps, isDragActive, getInputProps, open } = useDropzone({
    disabled: !isEnabled || isUploadingMedia,
    noClick: true,
    noKeyboard: true,
    multiple: true,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/webp": [".webp"],
      "image/svg+xml": [".svg"],
      "video/mp4": [".mp4"],
      "video/quicktime": [".mov"],
      "video/webm": [".webm"],
    },
    onDrop: (acceptedFiles) => {
      if (isUploadingMedia || acceptedFiles.length === 0) {
        return;
      }
      uploadAssetMedias(acceptedFiles);
    },
  });

  return {
    isUploadingMedia,
    getRootProps,
    isDragActive,
    getInputProps,
    open,
  };
}
